import React, { useEffect } from "react";

import DatatablePage from "../../../layout/datatable-pages/investors";
import { fetchData, getInvestorsFieldsArray } from "../../../utils/helpers";
import { props } from "../../datatable/props";
import useDatatable from "../../hooks/useDatatable";

import "../../data/datatable-pages.css";
import { useSupabaseApp } from "../../../SupabaseApp";

/**
 * EarlyStage Component (Early Stage Funding Sourcing)
 * 
 * Browse and discover early stage funding sources including accelerators,
 * venture capital firms, and other founder-friendly funding providers.
 * Users can search through 43+ investor attributes including investment range,
 * track record, and geographic preferences. Displays investor statistics.
 * Requires user authentication.
 * 
 * @returns {JSX.Element} Datatable page with early stage funding sources
 */
const EarlyStage = () => {
  // Array of investor field keys to display in the datatable (43 fields for sourcing)
  const fieldKeys = [
    "name",
    "investorType",
    "description",
    "numOfFailedInvestments",
    "lossOnInvestments",
    "shutteredPortfolioCompanies",
    "numOfExit",
    "exitValue",
    "reputation",
    "location",
    "investmentStage",
    "investmentTrackRecord",
    "assets",
    "investmentRange",
    "sweetSpot",
    "investmentFocus",
    "investmentGeography",
    "numOfInvestments",
    "numOfLeadInvestments",
    "numOfFollowOnInvestments",
    "numOfCoInvestments",
    "numOfAcquisitions",
    "boardSeats",
    "numOfFunds",
    "limitedPartners",
    "coInvestors",
    "numofPartners",
    "partners",
    "numOfEmployeesObj",
    "management",
    "boardMembers",
    "founders",
    "email",
    "socialMedia",
    "website",
    "phone",
    "address",
    "entityType",
    "legalName",
    "primaryBusinessName",
    "formerlegalName",
    "founded",
    "stockSymbol",
  ];

  const fields = getInvestorsFieldsArray(fieldKeys);

  const { datatableProps } = useDatatable();

  // realm functions declaration
  const { currentUser, supabase, getUserTier } = useSupabaseApp();

  // check if user is logged in or not
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // params for functions
  const params = {
    supabase,
    ...datatableProps,
    getData: "getEarlyStageFunding",
    collection: "investors",
    title: "Early stage funding",
    datatipText:
      "Search for funding with our founder-friendly collection of accelerator, venture capital, and other early stage funding sources.",
    statsArray: [
      {
        actualName: "financingSources",
        displayName: "Financing sources",
        total: "20,000",
      },
    ],
    placeholderText: "Search from early stage funding",
    fields: fields,
    getCompanyDetailsForExpand: "getCompanyDetailsForExpand",
  };

  // fetch data on page load
  useEffect(() => {
    fetchData(params);
  }, []);

  return <DatatablePage props={props(params)} />;
};

export default EarlyStage;
